import React from "react";
import { MdOutlineWbSunny } from "react-icons/md";
import { FiMoon } from "react-icons/fi";

interface ThemeSwitchProps {
  theme: "light" | "dark";
  toggleTheme: () => void;
}

export const ThemeSwitch: React.FC<ThemeSwitchProps> = ({ theme, toggleTheme }) => {
  const isDark = theme === "dark";

  return (
    <button
      onClick={toggleTheme}
      className="absolute top-5 right-5 w-9 h-9 rounded-xl border border-border bg-surface hover:bg-surface-hover flex items-center justify-center transition-all active:scale-90 z-header text-text"
      title="Cambiar tema"
    >
      {isDark ? <MdOutlineWbSunny size={18} /> : <FiMoon size={16} />}
    </button>
  );
};
